import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { MarkDirectorNotificationAsReadUseCaseInterface } from 'domain/usecases';

export class RemoteMarkDirectorNotificationAsRead
  implements MarkDirectorNotificationAsReadUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<MarkDirectorNotificationAsReadUseCaseInterface.Result>,
  ) {}

  async execute(
    params: MarkDirectorNotificationAsReadUseCaseInterface.Params,
  ): Promise<MarkDirectorNotificationAsReadUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'patch',
      url: `${this.url}/${params.notificationHashId}/read`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
